import { useId } from "react";
import PropTypes from "prop-types";
import { HoverCard } from "@hireart/component-library";
import { Right, Value } from "./styles";

export const RightWithHover = ({ content, theme, width, category }) => {
  const popupId = useId();
  return (
    <HoverCard
      id={popupId}
      content={`${content} hours ${category}`}
      trigger={
        <Right width={width} style={theme}>
          <Value>{content}</Value>
        </Right>
      }
    />
  );
};

RightWithHover.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  width: PropTypes.PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};
